import { trans } from "@mongez/localization";
import { SectorServicesSlider } from "./SectorServicesSlider";

type KeyServicesSectionProps = {
  services:
    | string[]
    | {
        title: string;
        abbreviation: string;
      }[];

  icon?: string;
};

export function KeyServicesSection({
  services,
  icon,
}: KeyServicesSectionProps) {
  return (
    <div className="bg-[#F7F9FC]">
      <div className="container flex flex-col gap-6 py-12 lg:gap-10 lg:py-24">
        <div className="flex items-center gap-4">
          {icon && (
            <img
              src={icon}
              alt={trans("keyServices")}
              className="size-36 object-contain"
            />
          )}
          <h2 className="text-3xl font-medium text-secondary sm:text-4xl lg:text-7xl">
            {trans("keyServices")}
          </h2>
        </div>
        <SectorServicesSlider services={services} />
      </div>
    </div>
  );
}
